import List from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { MenuItemRow } from "./MenuItemRow";

/**
 * Render recursivo "en árbol" (con animación de Collapse por nivel). Se usa
 * mientras la cantidad de filas visibles esté por debajo del umbral de
 * virtualización — ver constants.VIRTUALIZE_THRESHOLD y Sidebar.js.
 */
export function MenuTree({ items, depth = 0, compact, openSubMenus, onToggle, isRouteActive, hasActiveRouteInTree, isFavorite, onToggleFavorite, onSelectLeaf }) {
  return (
    <>
      {items.map((item) => {
        const hasChildren = item.children && item.children.length > 0;
        const isOpen = Boolean(openSubMenus[item.id]);
        const isCurrentRouteActive = isRouteActive(item.route);
        const isChildRouteActive = hasChildren ? item.children.some(hasActiveRouteInTree) : false;

        const handleSelect = () => {
          if (hasChildren) {
            onToggle(item.id);
            return;
          }
          onSelectLeaf(item);
        };

        return (
          <div key={item.id}>
            <MenuItemRow
              item={item}
              depth={depth}
              compact={compact}
              isOpen={isOpen}
              isCurrentRouteActive={isCurrentRouteActive}
              isChildRouteActive={isChildRouteActive}
              isFavorite={isFavorite(item.id)}
              onToggleFavorite={onToggleFavorite}
              onSelect={handleSelect}
            />

            {hasChildren && !compact && (
              <Collapse in={isOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding className="pb-1">
                  <MenuTree
                    items={item.children}
                    depth={depth + 1}
                    compact={compact}
                    openSubMenus={openSubMenus}
                    onToggle={onToggle}
                    isRouteActive={isRouteActive}
                    hasActiveRouteInTree={hasActiveRouteInTree}
                    isFavorite={isFavorite}
                    onToggleFavorite={onToggleFavorite}
                    onSelectLeaf={onSelectLeaf}
                  />
                </List>
              </Collapse>
            )}
          </div>
        );
      })}
    </>
  );
}
